import { useSelector } from 'react-redux'

import VideoTutorialSet from '../../../components/ReusableComponents/VideoTutorial/index'
import { generateOperaVideoSteps } from './Instructions/index'

const OperaSetup = () => {
  const { subsidiaryList, currentHotelId } = useSelector(s => s.login)
  const subsidiaryShortLinkToken = subsidiaryList.find(
    s => s.subsidiaryId === currentHotelId
  ).subsidiaryShortLinkToken
  const operaVideoSteps = generateOperaVideoSteps(subsidiaryShortLinkToken)

  return (
    <VideoTutorialSet
      steps={operaVideoSteps}
      subsidiaryShortLinkToken={subsidiaryShortLinkToken}
    />
  )
}

export default OperaSetup
